import React, { useCallback, useMemo, useState } from "react";
// Constants
import { useTheme } from "@fluentui/react";
import { ChoiceGroup, DefaultButton, PrimaryButton } from "@fluentui/react";
import { Dialog, DialogFooter, DialogType as FabricDialogType } from "@fluentui/react";
// Styles
import { getClassNames, getDeleteRecurringTaskDialogContentStyles, getDeleteRecurringTaskDialogStyles } from "./DeleteRecurringTaskDialog.styles";
// Utilities
import { css } from "@fluentui/utilities/lib/css";
import { Strings } from "@ms/uno-resources/lib/local/CultureUtilities";
/**
 * Enum representing delete options
 */ var TaskDeleteOption = /*#__PURE__*/ function(TaskDeleteOption) {
    TaskDeleteOption["Task"] = "task";
    TaskDeleteOption["Series"] = "series";
    return TaskDeleteOption;
}(TaskDeleteOption || {});
/**
 * The Delete Task dialog control.
 */ export function DeleteRecurringTaskDialog(props) {
    const { contentStyles, dialogClassName, dialogContentClassName, dialogContainerClassName, layerProps, focusTrapZoneProps, deleteTaskSeries, deleteTask, onDismiss } = props;
    const theme = useTheme();
    const defaultState = getDefaultState(props);
    const classNames = getClassNames(theme, contentStyles);
    const [state, setState] = useState(defaultState);
    const dialogStyles = getDeleteRecurringTaskDialogStyles(theme);
    const dialogContentStyles = getDeleteRecurringTaskDialogContentStyles(theme);
    /**
     * Listen to delete option change
     * @param ev The html element
     * @param selectedChoice The new delete option
     */ const onDeleteOptionChange = useCallback((ev, selectedChoice)=>{
        setState({
            deleteOption: selectedChoice.key
        });
    }, []);
    /**
     * Listen to delete option change
     */ const onDeleteTaskClicked = useCallback(()=>{
        switch(state.deleteOption){
            case "task":
                deleteTask();
                break;
            case "series":
                deleteTaskSeries();
                break;
            default:
                break;
        }
    }, [
        state.deleteOption,
        deleteTask,
        deleteTaskSeries
    ]);
    /**
     * Render this component
     */ return /*#__PURE__*/ React.createElement(Dialog, {
        hidden: false,
        onDismiss: onDismiss,
        dialogContentProps: {
            type: FabricDialogType.close,
            className: dialogContentClassName,
            title: Strings.TaskRecurrence_DeleteTaskTitle,
            styles: dialogContentStyles
        },
        styles: dialogStyles,
        modalProps: {
            className: css(dialogClassName, "deleteRecurringTaskDialog"),
            containerClassName: css(dialogContainerClassName, "taskDeleteDialogContainer"),
            isBlocking: false,
            layerProps: layerProps,
            focusTrapZoneProps: focusTrapZoneProps
        }
    }, /*#__PURE__*/ React.createElement("div", null, /*#__PURE__*/ React.createElement(ChoiceGroup, {
        className: classNames.taskChoice,
        selectedKey: state.deleteOption,
        options: useMemo(()=>getDeleteOptionList(), []),
        onChange: onDeleteOptionChange
    }), /*#__PURE__*/ React.createElement(DialogFooter, null, /*#__PURE__*/ React.createElement(PrimaryButton, {
        className: "deleteTaskButton",
        onClick: onDeleteTaskClicked
    }, Strings.TaskRecurrence_DeleteTaskConfirm), /*#__PURE__*/ React.createElement(DefaultButton, {
        className: "cancelDelete",
        onClick: onDismiss
    }, Strings.TaskRecurrence_DeleteTaskCancel))));
}
function getDefaultState(props) {
    return {
        deleteOption: "task"
    };
}
/** Dropdown options for delete */ function getDeleteOptionList() {
    return [
        {
            key: "task",
            className: "task",
            text: Strings.TaskRecurrence_DeleteTaskOptionForTask
        },
        {
            key: "series",
            className: "series",
            text: Strings.TaskRecurrence_DeleteTaskOptionForSeries
        }
    ];
}
